
<script>
    export let type = null;
    export let data = {};
    console.error(data);
</script>

<div id="nsMessageWrapper">
    {#if  type === "url"}
        <h1 id='nsMessage'>No Matching Session. Check the URL.</h1>
    {:else if type === "auth"}
        <h1 id='nsMessage'>Room Not Authorized. <a href="https://post-link.io/dashboard" target="_blank">Log in to the dashboard</a> to get access.</h1>
    {:else if type === "browser"}
        <h1 id='nsMessage'>Browser Not Supported. <a href="https://post-link.io/docs/#links" target="_blank">Check the docs</a> for more info.</h1>
    {:else if type === "isolation"}
        <h1 id='nsMessage'>This browser or network is blocking required security headers. Try another browser, or disable extensions and <a href={location.href} on:click|preventDefault={() => location.reload()}>reload</a>.</h1>
    {:else}
        <h1 id='nsMessage'>Something Went Wrong. <a href={location.href} on:click|preventDefault={() => location.reload()}>Reload</a> to try again.</h1>
    {/if}

</div>

<style>

#nsMessageWrapper{
    /* display: flex; */
    /* justify-content: center;
    align-items: center; */
    /* height: 100vh; */
    margin: 1em;

}

#nsMessage {

    font-family:  "Helvetica", sans-serif;
    font-weight: 325;
    font-size: 20px;
    color: antiquewhite;
    background: #ff0d0d94;
    padding: 0.5em;
    border-radius: 10px;
    /* box-shadow: 1px 1px 8px 3px #787878ad; */
    
}

a {
    color: white;
    text-decoration: underline;
}


</style>
